import { enumOf, objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

import { surveyQuestionTypes } from "./constants";
import type { SurveyQuestionType } from "./types";

export const isSurveyDefinition = objectOf({
  allow_multiple_responses: boolean,
  survey_questions: arrayOf(
    objectOf({
      question_eid: string,
      question_text: string,
      question_type: enumOf<SurveyQuestionType>(...surveyQuestionTypes),
      marked_as_deleted: boolean,
      id: maybe(string, true),
      choices: maybe(arrayOf(string)),
      deleted_choices: maybe(arrayOf(string)),
    })
  ),
  id: string,
});
